// GENERATED FILE — do not edit by hand.
// Produced by web/scripts/generate-allowed-return-to.mjs from the Janus
// boundary manifest at SSM /francisquiniai/janus/boundaries/latest.
// Source: SSM /francisquiniai/janus/boundaries/latest
// See docs/specs/janus/00-index.md (Phase 1.B).

export const ALLOWED_RETURN_TO_HOSTS: readonly string[] = [
  "https://cuidari.com",
  "https://app.cuidari.com",
  "https://www.cuidari.com",
  "https://ariadne.francisquini.ai",
  "https://cuidari.francisquini.ai",
  "https://console.francisquini.ai",
  "https://mentor.francisquini.ai",
  "http://localhost:5173",
  "http://localhost:3000",
  "http://localhost:8080",
  "http://127.0.0.1:5173",
  "http://127.0.0.1:3000",
  "https://app.ibirami.com",
];
